import withLazyLoading from '../../hoc/withLazyLoading';
import EscalationLevel from '../../pages/EscalationLevel';
import { createCrumbHandle, validatePermission } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';

const Plants = withLazyLoading(() => import('../../pages/Plants'));
const PlantConfiguration = withLazyLoading(() => import('../../pages/PlantConfiguration'));
const PlantVisualisationConfig = withLazyLoading(() => import('../../pages/PlantVisualisationConfig'));
const PlantVisualisationParent = withLazyLoading(() => import('../../pages/PlantVisualisationParent'));
const DataInputs = withLazyLoading(() => import('../../pages/DataInputs'));
const DataInputv2 = withLazyLoading(() => import('../../pages/DataInputv2'));
const DataInputConfigurationv2 = withLazyLoading(() => import('../../pages/DataInputConfigurationv2'));
const Sensors = withLazyLoading(() => import('../../pages/Sensors'));
const DataBreakForPlant = withLazyLoading(() => import('../.././components/DataBreak/DataBreakView'));
const DataBreakDetailsForSinglePlant = withLazyLoading( () => import('../.././components/DataBreak/DataBreakForPlantView'));
const ChemicalComposition = withLazyLoading(() => import('../../pages/ChemicalComposition'));
const BiDirectionalLogs = withLazyLoading(() => import('../../pages/BiDirectionalLogs'));

const plantRoutes = [
    {
        path: '/plants',
        handle: createCrumbHandle('Assets'),
        children: [
            { 
                index: true,
                element: <Plants />,
                loader: validatePermission('PlantsList_View_R'),
            },
            {
                path: 'PlantConfig/:id',
                element: <PlantConfiguration />,
                // loader: validatePermission('PlantsList_Manage_E'),
                handle: createCrumbHandle('Asset Configuration'),
            },
            {
                path: 'sensors/:plantId',
                element: <Sensors />,
                loader: validatePermission('Sensor_Configuration_WE'),
                handle: createCrumbHandle('Sensors'),
            },
            {
                path: 'DataInputConfigv2/:id',
                element: <DataInputConfigurationv2 />,
                // loader: validatePermission('PlantLabTestResults_Configuration_WE'),
                handle: createCrumbHandle('Data Input Configuration'),
            },
            { // @obsolete
                path: 'DataInputs/:plantId',
                element: <DataInputs />,
                // loader: validatePermission('PlantLabTestResults_Configuration_WE'),
                handle: createCrumbHandle('Data Inputs'),
            },
            {
                path: 'escalation/:id',
                element: <EscalationLevel />,
                handle: createCrumbHandle('Escalation Levels'),
            },
        ]
    },
    {
        path: '/PlantVisualisationConfig/:plantId',
        element: <PlantVisualisationConfig />,
        loader: validatePermission('Visualisation_Configuration_WE'),
        handle: createCrumbHandle('Asset Visualization Configuration'),
    },
    {
        path: '/PlantVisualisation/:plantId',
        element: withPostHogTracker(<PlantVisualisationParent />),
        loader: validatePermission('Visualisation_View_R'),
        handle: createCrumbHandle('Asset Visualization'),
    },
    { // @obsolete
        path: '/data-inputv2/:plantId',
        element: <DataInputv2 />,
        // loader: validatePermission('PlantLabTestResults_Configuration_WE'),
        handle: createCrumbHandle('Data Inputs V2'),
    },
    {
        path: '/databreak',
        element: <DataBreakForPlant />,
        loader: validatePermission('DataBreakList_View_R'),
        handle: createCrumbHandle('Data Break'),
    },
    {
        path: '/databreakdetails/:assetId',
        element: <DataBreakDetailsForSinglePlant />,
        loader: validatePermission('DataBreakList_View_R'),
        handle: createCrumbHandle('Data Break Details'),
    },
    { // @obsolete
        path: '/ChemicalComposition/:plantId',
        element: <ChemicalComposition />,
        handle: createCrumbHandle('Chemical Composition'),
    },
    {
        path: '/BiDirectionalLogs/:plantId',
        element: <BiDirectionalLogs />,
        loader: validatePermission('OldVisualisation_View_R'),
        handle: createCrumbHandle('Bidirectional Logs'),
    },
];

export default plantRoutes;
